import { NgModule } from '@angular/core';
import { SharedPdfService } from 'app/services/shared/shared-pdf.service';


@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [SharedPdfService],
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/services/shared/shared.module.ts